module.exports = __webpack_public_path__ + "static/img/萬事拜託300x300.9dae682b.png";